import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { authClient } from "@/lib/auth-client";
import { ForgotPasswordForm } from "@/components/auth/forgot-password-form";

export const Route = createFileRoute("/forgot-password")({
  beforeLoad: async () => {
    const { data: session } = await authClient.getSession();
    if (session) {
      throw redirect({ to: "/" });
    }
  },
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  return (
    <div className="login-bg min-h-screen flex flex-col items-center justify-center px-6 py-12">
      {/* Logo */}
      <img
        src="/paris-safety-logo.png"
        alt="Paris Mechanical"
        className="w-56 md:w-64 mb-3 object-contain"
      />
      <p className="text-text-tertiary text-sm tracking-wider mb-10">
        Password Recovery
      </p>

      {/* Glass card */}
      <div className="glass-card rounded-xl shadow-2xl w-full max-w-sm p-8">
        <ForgotPasswordForm />
      </div>

      {/* Back to login */}
      <Link to="/login" className="mt-8 text-sm text-text-tertiary hover:text-paris-red-text transition-colors">
        Back to Sign In
      </Link>
    </div>
  );
}
